import gql from 'graphql-tag';
import ORGANIZATION_FRAGMENT from 'graph/fragments/organization';

const GET_ORGANIZATIONS_INCLUDING_DISTRICT = gql`
  query getOrganizationsIncludingDistricts {
    organizations(
      where: { type: [DISTRICT, SCHOOL, USER_GROUP] }
      orderBy: { field: NAME, direction: ASC }
    ) {
      ...BaseOrganization
      subOrganizations {
        type
      }
      classrooms {
        id
        dateArchived
      }
      users {
        organizationRoles {
          classification
        }
        user {
          id
          type
          firstName
          lastName
          username
        }
      }
    }
  }
  ${ORGANIZATION_FRAGMENT}
`;

export default GET_ORGANIZATIONS_INCLUDING_DISTRICT;
